import $ from "jquery";

window.$ = window.jQuery = $;

$( document ).ready(
	function () {
		let search = document.querySelector('.search');
		// let searchBox = document.querySelector('.header__search-box');
		let searchIcon = document.querySelector('.search__icon');
		let searchInput = document.querySelector('.search-field');
		let customField = document.querySelector('.custom-field');
		let body = document.querySelector('body');
		let button = document.querySelector('button');

		customField.addEventListener('click', function(event) {
			// var isClickInside = searchIcon.contains(event.target);
			// search.classList.add('search-open');

			var isClickInside = customField.contains(event.target);
			customField.classList.add('search-open');
			body.classList.add('search-open');
			button.style.display = "block";
			searchInput.focus();

		});

		// Capture clicks outside language toggle.
		$(document).on('click touch', function (event) {
      let $target  = $(event.target);

      if (!$target.closest('.search').length) {
        $('.custom-field').removeClass('search-open');
				$('body').removeClass('search-open');
      }
    });
	}
);